import { FormManager } from '@bark/bark-core/src/components/legacy-scripts/form-manager';
import {_t, PaginationManager } from '@bark/bark-core';
import { exposeQuickScrollToWindow } from "@bark/bark-core";
import { AsYouType } from 'libphonenumber-js'
import moment from "moment/moment";
import {getFullLocale} from "@bark/bark-core/src/helpers";
import {currency} from "@bark/bark-core/src/helpers/number-formatting";

export default function BillingDetailsSettings() {
	exposeQuickScrollToWindow();

	const formManager = FormManager();

	let paginationManager;

	/**
     * Window.Bark global
     * @type {Window.Bark}
     */
	var Bark = window.Bark = window.Bark || {};

	/**
     * Window.Bark.billing global
     * @type {Window.Bark.billing}
     */
	var billing = Bark.billing = Bark.billing || {};

	/**
     * An object of required data
     * @type {Window.Bark.billing.data}
     */
	var data = billing.data = billing.data || {};

	/**
     * Templates
     * @type {Window.Bark.billing.templates}
     */
	var templates = billing.templates = billing.templates || {};

	/**
     * The amount of items to get
     * @type {number}
     */
	var paginationItems = 10;

	/**
     * An object describing what AJAX requests are pending
     * @type {object}
     */
	var pendingAjax = {invoices: false};

	/**
     * Flag to determine whether it is okay to check invoices
     * @type {boolean}
     */
	var allowCheckInvoices = true;

	/**
     * The maximum number of autocomplete results
     * @type Number
     */
	var N_AUTOCOMPLETE_RESULTS = 5;

	/**
     * A handlebars template for an invoice row
     * @type {boolean}
     */
	templates.invoiceRow = false;

	/**
     * An array of objects describing invoices
     * @type {Array}
     */
	data.invoices = [];

	/**
     * Append invoices
     * @param {array} invoices
     */
	function appendToInvoices(invoices) {
		var i;
		var invoice;

		if (invoices.length) {
			$('.js-invoices-section').removeClass('d-none');
		}

		if (!billing.templates.invoiceRow) {
			billing.templates.invoiceRow = Handlebars.compile(document.getElementById('handlebars-invoices-row').innerHTML);
		}

		for (i = 0; i < invoices.length; i++) {
			invoice = invoices[i];
			const invoiceDate = moment(invoice.created, 'YYYY-MM-DD HH:mm:ss').toDate()
				.toLocaleString(getFullLocale(), {
					day: 'numeric',
					month: 'short',
					year: 'numeric',
				});

			$('.js-invoices-table .js-pseudo-body').append(billing.templates.invoiceRow({
				invoice_id: invoice.id,
				invoice_total: currency(invoice.total_pence / 100),
				stripe_invoice_id: invoice.stripe_invoice_id ?? invoice.id ,
				is_paid: invoice.is_paid,
				invoice_date: invoiceDate,
				invoice_paid_on_text: _t("seller_settings_billing:billing-address.invoice-paid-on-date.text", {
					invoice_id: invoice.id,
					paid:`<span class="text-success px-1">${_t('seller_settings_billing:billing-address.invoice-paid-on-date.paid')}</span>`,
					invoice_date: invoiceDate,
					interpolation: {escapeValue: false}
				}),
				invoice_on_text: _t('seller_settings_billing:billing-address.invoice-on-date.text',{invoice_id: invoice.id, invoice_date: invoiceDate})
			}));
		}
	}

	/**
     * Get a log of all of the invoices for a seller
     */
	billing.getInvoicesLog = function () {
		var pn = (Math.floor(billing.data.invoices.length / paginationItems) * paginationItems) + 1;

		if (pendingAjax.invoices || !allowCheckInvoices) {
			return;
		}

		pendingAjax.invoices = true;

		if (!billing.data.invoices.length) {
			$('.js-invoices-table .js-pseudo-body').empty();
		}
		$('#invoices-table').addClass('waiting');

		Bark.api('seller/invoices/' + pn, null, function (e) {
			pendingAjax.invoices = false;

			billing.data.invoices = billing.data.invoices.concat(e.data.invoices);

			allowCheckInvoices = e.data.invoices.length === paginationItems;

			appendToInvoices(e.data.invoices);
			$('#invoices-table').removeClass('waiting');
			paginationManager.output('#invoices-pagination', e.data.last_page, e.data.current_page, function (b) {
				billing.getInvoicesLogFromPage(b);
			});
			$('#invoices-table').css('min-height', $('#invoices-table').height());
		}, function () {
			// @todo error handling
		});
	};

	billing.getInvoicesLogFromPage = function (pageNumber) {
		if (pendingAjax.invoices || $('#invoices-table').hasClass('waiting')) {
			return;
		}
		pendingAjax.invoices = true;
		quickScroll($('.js-invoices-section'), -90);
		$('#invoices-table').addClass('waiting');
		$('.js-invoices-table .js-pseudo-body').empty();
		Bark.api('seller/invoices/' + pageNumber, null, function (e) {
			pendingAjax.invoices = false;
			billing.data.invoices = billing.data.invoices.concat(e.data.invoices);
			appendToInvoices(e.data.invoices);
			$('#invoices-table').css('min-height', 'initial');
			$('#invoices-table').removeClass('waiting');
			paginationManager.output('#invoices-pagination', e.data.last_page, e.data.current_page, function (b) {
				billing.getInvoicesLogFromPage(b);
			});
			$('#invoices-table').css('min-height', $('#invoices-table').height());
		}, function () {
			$('#invoices-table').removeClass('waiting');
			// @todo error handling
		});
	}
	/**
     * Update the billing address
     */
	billing.updateBillingAddress = function (deferred) {
		var payload = {
			billing_contact_name: $('#billing_contact_name').val().trim(),
			billing_address_1: $('#billing_address_1').val().trim(),
			billing_address_2: $('#billing_address_2').val().trim(),
			billing_phone_number: $('#billing_phone_number').val().trim().replace(/\ /g, ''),
			billing_city: $('#billing_city').val().trim(),
			billing_postcode: $('#billing_postcode').val().trim(),
		};
		var streamcompleteItem = getStreamcompleteItem('#billing_postcode');

		if (!validateBillingAddress(payload)) {
			deferred.reject($('label[for="billing_contact_name"]'));
			return;
		}

		if (streamcompleteItem) {
			payload.billing_postcode_id = streamcompleteItem.id;
		}

		Bark.showLoading();

		Bark.api('seller/billing-address', payload, function (e) {
			Bark.hideLoading();
			if (e.status) {
				$('#update-billing-address-modal').modal('hide');
				getBillingAddress(false);
				deferred.resolve();
				formManager.dirty('billing-account-address', false);
				return;
			}

			if (e.errors) {
				deferred.reject($('label[for="billing_contact_name"]'));
				handleFormErrors(e.errors);
				return;
			}

			$('#update-billing-address-modal').modal('hide');
			errorModal(_t('seller_settings_billing:billing-address.errors.saving-address'));
		}, function () {
			deferred.reject($('label[for="billing_contact_name"]'));
			errorModal();
			Bark.hideLoading();
		}, 'POST');
	};

	/**
     * AJAX to update the VAT status
     * @param {boolean} withDeferred <b>True</b> to use deferring
     */
	billing.updateVatStatus = function (deferred) {
		var elem = $('#billing_vat_registration_status');
		var original = elem.data('original');

		if (+original === +elem[0].checked) {
			console.log('matched!');
			deferred.resolve();
			formManager.dirty('billing-account-vat', false);
			return true;
		}

		Bark.showLoading();

		Bark.api('seller/toggle-vat-status', {is_registered: +elem[0].checked}, function () {
			console.log('updating vat status');
			deferred.resolve();
			getBillingAddress(false);
			formManager.dirty('billing-account-vat', false);
			Bark.hideLoading();
		}, function () {
			deferred.reject($('label[for="billing_vat_registration_status"]'));
			console.error('Failed to toggle vat status');
			Bark.hideLoading();
		}, 'POST');
		return true;
	};

	/**
     * AJAX to update an email address
     * @param {boolean} withDeferred <b>True</b> to use deferring
     */
	billing.updateEmailAddress = function(deferred) {
		var payload = {
			email: $('#user_email_address').val()
		};

		if (!validateUpdateEmail(payload.email)) {
			deferred.reject($('label[for="user_email_address"]'));
			return false;
		}

		if (payload.email === $('#user_email_address').data('original-email')) {
			deferred.resolve();
			formManager.dirty('billing-account-email', false);
			return true;
		}

		Bark.showLoading();

		Bark.api('user/email', payload, function (e) {
			Bark.hideLoading();

			if (e.errors) {
				handleFormErrors(e.errors);
				deferred.reject($('label[for="user_email_address"]'));
				return;
			}

			if (e.status) {
				Bark.json({url: '/json/reset-seller-session/'}).fail(function () {
					Bark.jsr.logError('reset-seller-session', 'Email updated ok. Failed to set session');
					console.error('Email address was updated okay, but there was an error updating your session.');
				});

				$('#user_email_address').data('data-original-email', payload.email);

				deferred.resolve();
				formManager.dirty('billing-account-email', false);
				return;
			}

			deferred.reject($('label[for="user_email_address"]'));

			errorModal(_t('seller_settings_account-details:errors.email.default'));

		}, function (err) {
			Bark.hideLoading();
			deferred.reject($('label[for="user_email_address"]'));
			errorModal(_t('seller_settings_account-details:errors.email.default'));
		}, 'POST');

		return true;
	};

	/**
     * Handle form errors returned from the API
     * @param {array} errors An array of objects, with each object in the form<pre>
     *  {
     *      fieldname: string,
     *      msg: string
     *  }
     */
	function handleFormErrors(errors) {
		var i;

		for (i = 0; i < errors.length; i++) {
			if (errors[i].fieldname === 'general') {
				Bark.alertModal(errors[i].msg, _t('seller_common:close-button'));
			} else {
				Bark.showFormErrorsBootstrap(errors[i].fieldname, errors[i].msg);
			}
		}
	}

	/**
     * Show the error modal
     * @param {string} msg [optional] The error message to show
     * @param {boolean} keepModalsOpen [optional] True to keep the current modal open
     */
	function errorModal(msg, keepModalsOpen) {
		if (!keepModalsOpen) {
			$('.modal').modal('hide');
		}

		Bark.alertModal(msg || _t('seller_settings_billing:billing-address.errors.general'));
		Bark.hideLoading();
	}

	/**
     * Initialize the autocomplete plugin
     */
	function initPostcodeAutocomplete() {
		$('#billing_postcode').streamComplete({
			src: Bark.sprintf('%s/postcode-lookup/', Bark.ENV.api_hostname),
			requestmethod: 'get',
			delay: 10,
			usestandardsyntax: true,
			onclose: function () {
				$(this).removeClass('ajax-loading results-list-showing');
			},
			preprocessresults: function (data) {
				if (data.length > N_AUTOCOMPLETE_RESULTS) {
					data = data.slice(0, N_AUTOCOMPLETE_RESULTS);
				}

				for (var i = 0; i < data.length; i++) {
					var x = data[i];
					x.label = x.formatted;
				}

				return data;
			},
			onopen: function (data) {
				if (data.length) {
					$(this).addClass('results-list-showing');
				}
			},
			onresponse: function () {
				$(this).removeClass('ajax-loading');
			},
			onajaxerror: function () {
				$(this).removeClass('ajax-loading');
			},
			onbeforesearch: function (payload) {
				payload.coid = Bark.ENV.ccid;
			},
			onbeforeajaxsearch: function () {
				var sc = $(this).data('streamcomplete');
				sc.results = [];

				$(this).removeData('value streamcompleteItem'); // Remove existing vals
				$(this).addClass('ajax-loading');
			}
		});
		$('#billing_postcode').data({checkPostcode: false});
	}

	/**
     * Get streamcomplete item
     * @param {string} selector A selector for the target autocomplete
     * @returns {object} A streamcomplete item
     */
	function getStreamcompleteItem(selector) {

		if ($(selector).data('checkPostcode') == false) {
			return false;
		}

		var streamcompleteData;
		var streamcompleteItem = $(selector).data('streamcomplete-item');

		if (!streamcompleteItem) {
			streamcompleteData = $(selector).data('streamcomplete');

			if (streamcompleteData.results.length === 1) {
				streamcompleteItem = streamcompleteData.results[0];
			}
		}

		if (!streamcompleteItem) {
			return false;
		}

		return streamcompleteItem;
	}

	/**
     * Get the billing address and then render it
     */
	function getBillingAddress(withWaiting) {
		if (typeof withWaiting === 'undefined') {
			withWaiting = true;
		}
		if (withWaiting) {
			$('#billing_details').addClass('waiting');
		}

		Bark.api('seller/billing-address/', null, function (e) {
			if (e.status) {
				if (e.data) {
					$('#billing_contact_name').val(e.data.address_name);
					$('#billing_contact_name').data('original', e.data.address_name);
					$('#billing_address_1').val(e.data.address1);
					$('#billing_address_1').data('original', e.data.address1);
					$('#billing_address_2').val(e.data.address2);
					$('#billing_address_2').data('original', e.data.address2);
					$('#billing_phone_number').val(e.data.address_phone).trigger('keyup.format');
					$('#billing_phone_number').data('original', e.data.address_phone);
					$('#billing_city').val(e.data.address_city);
					$('#billing_city').data('original', e.data.address_city);
					$('#billing_postcode').val(e.data.address_postcode);
					$('#billing_postcode').data('original', e.data.address_postcode);

					$('#billing_details').removeClass('waiting');
				}
			} else {
				$('#billing_contact_name').val('');
				$('#billing_address_1').val('');
				$('#billing_address_2').val('');
				$('#billing_phone_number').val('').trigger('keyup.format');
				$('#billing_city').val('');
				$('#billing_postcode').val('');
				$('#billing_contact_name').data('original', '');
				$('#billing_address_1').data('original', '');
				$('#billing_address_2').data('original', '');
				$('#billing_phone_number').data('original', '');
				$('#billing_city').data('original', '');
				$('#billing_postcode').data('original', '');

				$('#billing_details').removeClass('waiting');
			}
		}, function (err) {
			// @todo error handling
		});
	}

	/**
     * Validate an email address locally
     * @param {string} emailAddress The email address to validate
     * @returns {boolean}
     */
	function validateUpdateEmail(emailAddress) {
		if (!emailAddress) {
			Bark.showFormErrorsBootstrap('user_email_address', _t('seller_settings_account-details:errors.email.no-email'));
			return false;
		}

		if (!emailAddress.match(/.*\@.*\./)) {
			Bark.showFormErrorsBootstrap('user_email_address', _t('seller_settings_account-details:errors.email.invalid-email'));
			return false;
		}

		return true;
	}

	/**
     * Validate the updated password
     * @param {string} currentPassword The old password
     * @param {string} newPassword The proposed new password
     * @param {string} confirmPassword Confirmation of the new password
     * @param loginMethod
     * @returns {boolean} <b>True</b> if the password passed local validation
     */
	function validateUpdatePassword(currentPassword = '', newPassword = '', confirmPassword = '', loginMethod = 'password') {

		const isLoginMethodPassword = loginMethod === 'password';

		if (isLoginMethodPassword && !currentPassword) {
			Bark.showFormErrorsBootstrap('account_current_password', _t('seller_settings_account-details:errors.password.no-current'));
			return false;
		}

		if (!newPassword) {
			Bark.showFormErrorsBootstrap('account_new_password', _t('seller_settings_account-details:errors.password.no-new'));
			return false;
		}

		if (newPassword.length < 6) {
			Bark.showFormErrorsBootstrap('account_new_password', _t('seller_settings_account-details:errors.password.too-short'));
			return false;
		}

		if (isLoginMethodPassword && currentPassword === newPassword) {
			Bark.showFormErrorsBootstrap('account_new_password', _t('seller_settings_account-details:errors.password.same-as-existing'));
			return false;
		}

		if (confirmPassword !== newPassword) {
			Bark.showFormErrorsBootstrap('account_new_password_confirm', _t('seller_settings_account-details:errors.password.no-match'));
			return false;
		}

		return true;
	}


	/**
     * Validate the billing address form
     * @param {object} data An object with the data to validate
     * @returns {boolean}
     */
	function validateBillingAddress(data) {
		var x;
		var streamcompleteItem = getStreamcompleteItem('#billing_postcode');

		for (x in data) {
			if (x !== 'billing_address_2' && !data[x]) {
				Bark.showFormErrorsBootstrap(x, _t('seller_settings_account-details:errors.billing.no-current'));
				return false;
			}
		}

		if ($('#billing_postcode').data('checkPostcode') && !streamcompleteItem) {
			Bark.showFormErrorsBootstrap('billing_postcode', _t('seller_settings_account-details:errors.postcode.invalid-postcode'));
			return false;
		}

		return true;
	}

	$(function () {
		paginationManager = new PaginationManager();

		Bark.billing.getInvoicesLog();
		getBillingAddress();

		$('.js-invoices-table .js-pseudo-body').off('scroll.listen').on('scroll.listen', function () {
			if ($('.js-invoices-table .js-pseudo-tr:last').isVisibleInParent(100)) {
				billing.getInvoicesLog();
			}
		});

		// ⚠️ Warning: this function is used by the BUYER account details screen.
		// In fact, this entire file is included by that screen. Don't ask me why, I'm just the messenger.
		$('.js-update-password').off('click.update').on('click.update', function () {

			const loginMethod = $('#login_method_for_change_password').val();
			let payload = {
				newpass: $('#account_new_password').val(),
				currentpass: null
			};

			if (loginMethod === 'password') {
				payload.currentpass = $('#account_current_password').val();
			}

			if (!validateUpdatePassword(payload.currentpass, payload.newpass, $('#account_new_password_confirm').val(), loginMethod)) {
				return;
			}

			Bark.showLoading();

			Bark.api('user/password-web', payload, function (e) {
				if (e.status) {
					$('#change-password-modal').modal('hide');

					// As the password is in the network logs in plain text, reload the page.
					document.location.reload();
					return;
				}

				Bark.hideLoading();

				if (e.errors) {
					handleFormErrors(e.errors);
					return;
				}

				Bark.alertModal(e.message || _t('seller_settings_account-details:errors.password.failed-to-change'));
			}, function () {
				errorModal();
				// @todo error handling
			}, 'POST');
		});

		if (Bark.ENV.ccid !== 109) {
			initPostcodeAutocomplete();
		} else {
			$('#billing_postcode').data({checkPostcode: false});
		}


		formManager.register('billing-account-email', function (deferred) {
			billing.updateEmailAddress(deferred);
		}, function () {
			$('#user_email_address').val($('#user_email_address').data('original-email'));
			formManager.dirty('billing-account-email', false);
		});
		$('#user_email_address').off('change.update, keyup').on('change.update, keyup', function () {
			formManager.dirty('billing-account-email', $(this).data('original-email') !== $(this).val().trim());
		});

		formManager.register('billing-account-vat', function (deferred) {
			billing.updateVatStatus(deferred);
		}, function () {
			$('#billing_vat_registration_status').prop('checked', $('#billing_vat_registration_status').data('original'));
		});
		$('#billing_vat_registration_status').off('change.update').on('change.update', function () {
			var isDirty = $(this).data('original') == 0 ? $(this).prop('checked') : !$(this).prop('checked');
			formManager.dirty('billing-account-vat', isDirty);
		});

		formManager.register('billing-account-address', function (deferred) {
			billing.updateBillingAddress(deferred);
		},
		function () {
			$('.js-billing-address-section :input').each(function (el) {
				if ($(this).data('original')) {
					$(this).val($(this).data('original'));
				}
				if ($(this).prop('type') === 'tel') {
					$(this).trigger('keyup.format');
				}
			});
			formManager.dirty('billing-account-address', false);
		});
		$('.js-billing-address-section :input').off('change.update, keyup.change').on('change.update, keyup.change', function () {
			if (!$(this).hasClass('custom-control-input')) {
				// we will mark as dirty only if we know this field is meaningfully altered
				if ($(this).data('original') !== $(this).val().trim()) {
					formManager.dirty('billing-account-address');
				}
				// but we won't mark it as clean because we wont check all the fields
			}
		});

		$('#billing_phone_number').off('keyup.format').on('keyup.format', function (e) {
			if (Bark.in_array(e.keyCode, [8, 37, 39])) {
				return false;
			}
			this.value = new AsYouType((Bark.ENV.locale || 'GB').toUpperCase()).input(this.value);
		});

		// Trigger by default
		$('#phone_number').trigger('keyup.format');

	});


}
